import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

interface RateInputProps extends React.ComponentProps<typeof Input> {
    label?: string
}

export const RateInput = ({ label, className, ...props }: RateInputProps) => {
    return (
        <div className="flex-1">
            {label && (
                <label className="mb-2 block text-sm font-medium text-foreground">
                    {label}
                </label>
            )}
            <Input
                type="number"
                step="0.01"
                className={cn(
                    'h-11 rounded-[12px] border-0 bg-secondary text-sm',
                    className
                )}
                {...props}
            />
        </div>
    )
}

interface CurrencyInputProps extends React.ComponentProps<typeof Input> {
    currency?: string
    icon?: React.ReactNode
    showPercentage?: boolean
    showPercentageLeft?: boolean
}

export const CurrencyInput = ({
    currency,
    icon,
    showPercentage,
    showPercentageLeft,
    className,
    ...props
}: CurrencyInputProps) => {
    return (
        <div className="relative flex-1">
            {showPercentageLeft && (
                <div className="absolute left-4 top-1/2 -translate-y-1/2 text-sm text-muted-foreground">
                    %
                </div>
            )}
            <Input
                type="number"
                step="0.01"
                className={cn(
                    'h-11 rounded-[12px] border-0 bg-secondary text-sm',
                    icon || currency ? 'pr-16' : '',
                    showPercentage ? 'pr-12' : '',
                    showPercentageLeft ? 'pl-10' : '',
                    className
                )}
                {...props}
            />
            {showPercentage && (
                <div className="absolute right-4 top-1/2 -translate-y-1/2 text-sm text-muted-foreground">
                    %
                </div>
            )}
            {(icon || currency) && (
                <div className="absolute right-4 top-1/2 flex -translate-y-1/2 items-center gap-2">
                    {icon}
                    {currency && (
                        <span className="text-sm font-medium text-foreground">
                            {currency}
                        </span>
                    )}
                </div>
            )}
        </div>
    )
}
